import AppConfig from '@/AppConfig';
import { useEffect, useRef } from 'react';
import { FCPMetric, LCPMetric } from 'web-vitals';

const sendToAnalytics = (
  metric: FCPMetric | LCPMetric,
  metricsRef: React.MutableRefObject<(FCPMetric | LCPMetric)[]>
) => {
  window.dev.i('Web Vitals', metric);
  window.dev.i('GTag', window.gtag, typeof window.gtag);
  if (window.gtag && typeof window.gtag === 'function') {
    window.gtag('event', metric.name, {
      event_category: 'Web Vitals',
      event_value: metric.value,
      event_rating: metric.rating,
      event_metric_id: metric.id,
      event_delta: metric.delta,
      non_interaction: true,
    });
  } else {
    metricsRef.current.push(metric);
  }
};

const useWebVitals = () => {
  const metricsRef = useRef<Array<FCPMetric | LCPMetric>>([]);

  // useEffect to handle the case when gtag is loaded before the component is mounted
  useEffect(() => {
    import('web-vitals').then(({ onFCP, onLCP }) => {
      onFCP((metrics) => sendToAnalytics(metrics, metricsRef));
      onLCP((metrics) => sendToAnalytics(metrics, metricsRef));
    });
  }, []);

  // useEffect to handle the case when gtag is loaded after the component is mounted
  useEffect(() => {
    const handleGtagLoaded = () => {
      window.dev.i('GTag is now Loaded');
      if (metricsRef.current.length > 0) {
        metricsRef.current.forEach((metric) => {
          sendToAnalytics(metric, metricsRef);
        });
        metricsRef.current = [];
      }
    };

    window.addEventListener(AppConfig.GA_LOADED_EVENT, handleGtagLoaded);

    return () => {
      window.removeEventListener(AppConfig.GA_LOADED_EVENT, handleGtagLoaded);
    };
  }, []);
};

export default useWebVitals;
